// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1_XU7","disabled":"FileBtn_disabled__1l7uE","warn":"FileBtn_warn__3wELN","fade":"FileBtn_fade__vCWKI"};